// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { pt } from "vuetify/locale";

// Vuetify
import { createVuetify } from 'vuetify'

const customThemeLight = {
  dark: false,
  colors: {
    primary: '#006E46',
    secondary: '#ef9b11',
    tertiary: '#478566',
  }
}

const customThemeDark = {
  dark: true,
  colors: {
    primary: '#006E46',
    secondary: '#ef9b11',
    tertiary: '#478566',
  }
}

export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  {
    locale: {
      locale: 'pt',
      fallback: 'pt',
      messages: { pt },
    },
    theme: {
      defaultTheme: 'customThemeLight',
      themes: {
        customThemeLight,
        customThemeDark
      },
    },
    defaults: {
      VCard: {
        elevation: 0,
      },
      VList: {
        density: 'compact',
      },
      VTextField: {
        density: 'compact',
        variant: 'outlined',
      },
      VSelect: {
        density: 'compact',
        variant: 'outlined',
      },
      VAutocomplete: {
        density: 'compact',
        variant: 'outlined',
      },
      VTextarea: {
        density: 'compact',
        variant: 'outlined',
      },
      VSwitch: {
        density: 'compact',
      },
      VCheckboxBtn: {
        color: 'primary',
        density: 'comfortable',
      },
      VAlert: {
        variant: 'outlined',
        color: '#757575',
        border: 'start',
        maxWidth: 500,
        class: 'mx-auto my-5 text-start'
      },
      VTabs: {
        bgColor: '#EEEEEE',
        sliderColor: 'primary',
        alignTabs: 'center',
      },
      VDataTable: {
        density: 'comfortable',
      },
    },
  }
)
